import { Component, Input } from '@angular/core';
// import { StatusSolicitacao } from '@/utils/status-solicitacao.utils';

@Component({
    selector: 'dp-tracking',
    templateUrl: './tracking.component.html',
    styleUrls: ['./tracking.component.scss']
})
export class TrackingComponent {
    @Input() public status: string;

    public showModal = false;
    public leavePage = false;
    public validatingCertificate = false;
    public invalidCertificate = false;

    // public get isApproved() {
    //     return StatusSolicitacao.isApproved(this.status);
    // }

    // public get isRejected() {
    //     return StatusSolicitacao.isRejected(this.status);
    // }

    // public get isOpen() {
    //     return StatusSolicitacao.isOpen(this.status);
    // }

    // public get isProcessing() {
    //     return StatusSolicitacao.isProcessing(this.status);
    // }

    // public get isPending() {
    //     return StatusSolicitacao.isPending(this.status);
    // }
}
